import React from 'react';
import HandshakeIcon from 'mdi-react/HandshakeIcon';
import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';
import { ROUTES } from './constants';

const Sidebar = ({
  isAllowedMenuItem,
  authorities,
  classes,
  toggleDrawer,
  currentPageTitle,
  setCurrentPageTitle,
  isSidebarItemActive,
  titleMapping,
  open,
}) => (
  <>
    {isAllowedMenuItem('GENERATE_PAYABLE', authorities) && (
      <ItemNavLink
        classes={classes}
        titleMapping={titleMapping}
        toggleDrawer={toggleDrawer}
        isSidebarItemActive={isSidebarItemActive}
        open={open}
        toUrl={ROUTES.ROOT}
        itemKey="reconciliation"
        iconComponent={<HandshakeIcon />}
        groupTitle="finance"
      />
    )}
  </>
);

export default Sidebar;
